import React, { useState } from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';
import TextButton from '~/components/atom/TextButton';
import InputWithButtons from '~/components/molecule/InputWithButtons';
import useGlobalKeyBinding from '~/hooks/useGlobalKeyBinding';
import Catalog from '~/Catalog';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import type { RefetchPlansQuery } from '../../types';

const text = {
  buttonLabel: 'Ik heb een Signup ID',
  inputLabel: 'Signup ID',
  confirmButton: Catalog.confirm,
  emptySignupIdError: 'Het veld kan niet leeg zijn',
  signupIdApplied: 'Signup ID toegepast: ',
};

export type Props = {
  initialValue: string | null;
  onUpdateSignupId: (signupId: string | null) => void;
  refetchPlans: RefetchPlansQuery;
};

const UpdateSignupIdButton: React.FCC<Props> = ({
  initialValue,
  onUpdateSignupId,
  refetchPlans,
}) => {
  const account = useCurrentAccount();
  const [showInput, setShowInput] = useState<boolean>(false);
  const [value, setValue] = useState<string>(initialValue ?? '');

  useGlobalKeyBinding({
    keys: 'enter',
    callback: () => {
      onConfirm();
    },
    enabled: value.length > 0,
  });

  const onConfirm = () => {
    if (value.length === 0) return;

    onUpdateSignupId(value || null);
    void refetchPlans({
      accountId: account.id,
      signupId: value,
    });
    setShowInput(false);
  };

  const onCancel = () => {
    setShowInput(false);
    setValue('');
    onUpdateSignupId(null);

    // reset query
    if (value.length > 0) {
      void refetchPlans({
        accountId: account.id,
        signupId: null,
      });
    }
  };

  return (
    <JustificationContainer width="100%">
      {showInput ? (
        <InputWithButtons
          buttonActions={[
            {
              icon: 'trashcan',
              appearance: 'danger',
              onClick: onCancel,
            },
            {
              icon: 'check',
              appearance: 'success',
              onClick: onConfirm,
            },
          ]}
          value={value}
          onChange={e => setValue(e.target.value)}
          width="100%"
          label={{ text: text.inputLabel }}
          autoFocus
        />
      ) : (
        <TextButton
          onClick={() => setShowInput(true)}
          label={!value ? text.buttonLabel : `${text.signupIdApplied}${value}`}
          appearance={value ? 'success' : 'primary'}
          icon={value ? 'check' : 'key'}
          padding={[null]}
        />
      )}
    </JustificationContainer>
  );
};

export default UpdateSignupIdButton;
